export default __webpack_public_path__ + "static/media/azure-icon-small.d8c693b6.svg";